import { MstBukaApi } from "@/api/MstBukaApi";
import { Buka } from "@/types/KoyouKeiyaku";
import { BukaDetail, GetBukaReq, UpsertBukaRes } from "@/types/MstBuka";
import { BaseOptionWithoutCode } from "@/types/Option";

export class MstBukaService {

  /**
   * 全ての所属会社の部課を取得します（オプション値）
   */
  public async getAll(): Promise<Buka[]> {
    const api = new MstBukaApi();
    try {
      return await api.getAll();
    } catch (e) {
      throw e;
    }
  }

  /**
   * 表示用の一覧を取得します
   */
  public async getList(cond?: GetBukaReq): Promise<BukaDetail[]> {
    const api = new MstBukaApi();
    try {
      return await api.getList(cond);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 表示用の詳細を取得します
   */
  public async getBukaDetail(bukaId: number): Promise<BukaDetail> {
    const api = new MstBukaApi();
    try {
      return await api.getBukaDetail(bukaId);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 全ての所属会社の部課を取得します（オプション値）
   */
  public async getAllOptions(): Promise<BaseOptionWithoutCode[]> {
    const api = new MstBukaApi();
    try {
      return await api.getAllOptions();
    } catch (e) {
      throw e;
    }
  }

  /**
   * 指定した所属会社の部課を取得します（オプション値）
   * @returns 指定した所属会社の部課一覧
   */
  public async getOptionsBySyozokuId(syozokuId: number): Promise<BaseOptionWithoutCode[]> {
    const api = new MstBukaApi();
    try {
      return await api.getOptionsBySyozokuId(syozokuId);
    } catch (e) {
      throw e;
    }
  }

  public async upsertBukaDetail(bukaDetail: BukaDetail) {
    const api = new MstBukaApi();
    try {
      return await api.upsert(bukaDetail);
    } catch (e) {
      throw e;
    }
  }

  public async deleteBuka(bukaId: number) {
    const api = new MstBukaApi();
    try {
      return await api.deleteBuka(bukaId);
    } catch (e) {
      throw e;
    }
  }
}
